import { Info } from 'lucide-react';
import { X } from 'lucide-react';
import React, {useEffect, useState} from 'react';
import './bandeau.scss'
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/store";
import {setBandeauAffichageEffacer} from "../../store/organisationSlice";
export function Bandeau() {
    const dispatch = useDispatch();
    const bandeau_contenu = useSelector<RootState, string>(state => state.organisation.bandeau_top.texte)

    if (bandeau_contenu === "") return <></>

    return (
        <>
            <div className={"bandeau_affichage"}>
                <p className={"flex-row"}><Info /> {bandeau_contenu}</p>
                <button className={"sec blanc noMargin"} onClick={() => {
                    dispatch(setBandeauAffichageEffacer());
                }}><X /></button>
            </div>
        </>

    );
}
